import { QualityRepository, CreateQualityInput } from '../../domain/repositories/quality.repository';
import { QualityEntity } from '../../domain/entities/quality.entity';

export class CreateQualityUseCase {
  constructor(private readonly qualityRepository: QualityRepository) {}

  async execute(input: CreateQualityInput): Promise<QualityEntity> {
    return this.qualityRepository.createQuality(input);
  }
}
